'use client';

import { useEffect } from 'react';
import { fetchMoneyRules } from '@/lib/money-rules';

/**
 * Загружает денежные правила (пороги подарков, бесплатной доставки, коинов)
 * один раз при старте приложения.
 *
 * НИЧЕГО НЕ РИСУЕТ и ничего не блокирует: до ответа витрина работает на
 * значениях по умолчанию, совпадающих с зашитыми в бэкенде. Ошибка запроса
 * тоже не всплывает наружу — человеку нечего делать с сообщением «не удалось
 * загрузить пороги», а итог заказа всё равно считает сервер.
 *
 * Запрос дешёвый: на бэкенде ручка кэширована (TTL + single-flight), ответ
 * отдаётся с Cache-Control: max-age=60.
 */
export function MoneyRulesInit() {
  useEffect(() => {
    void fetchMoneyRules();
  }, []);

  return null;
}
